import { render, staticRenderFns } from "./archivePhone.vue?vue&type=template&id=55fd75a6&scoped=true&"
import script from "./archivePhone.vue?vue&type=script&lang=js&"
export * from "./archivePhone.vue?vue&type=script&lang=js&"
import style0 from "./archivePhone.vue?vue&type=style&index=0&id=55fd75a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd75a6",
  null
  
)

export default component.exports